import type { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import type { GetSchemaVersionRequest, GetSchemaVersionResponse } from '../actions.js';
import { getSchemaVersion } from '../api.js';

// Re-export types for consumers
export type { GetSchemaVersionRequest, GetSchemaVersionResponse } from '../actions.js';

export function* getSchemaVersionSaga(payload: GetSchemaVersionRequest): SagaIterator {
  const schemaVersion: GetSchemaVersionResponse = yield call(getSchemaVersion, payload);
  const { schema } = schemaVersion;
  return schema;
}
